module.exports = __webpack_public_path__ + "static/media/paver_white.a381d8f3.svg";